import { routes } from './app-routes';

function compareIndex(a, b) {
  if (a.index > b.index) return 1;
  if (b.index > a.index) return -1;
  return 0;
}

export const getNavigationItems = () => {

  let navigationItems = [];
  for (let path in routes) {
    let route = routes[path];

    navigationItems.push({
      index: route.index,
      text: route.text,
      icon: route.icon,
      path: path,
      target: route.target,
      enabled: route.enabled,
      component: route.component
    });
  }

  // Sort by index
  return navigationItems.sort(compareIndex);
};
